import React, { useState, useContext, useEffect } from "react";

import {
  RadioGroup,
  Icon,
  ButtonAction,
  Select,
  Tooltip,
  FormGroup,
  Input
} from "xsolla-uikit";

import { GlobalContext } from "./PA";

import { platforms } from "./BlankKey";

import { KeyContext } from "./gk/PAgameKeys";

const platf = [
  // { label: "All platforms", value: "all" },
  { label: "Steam", value: "steam" },
  { label: "GOG", value: "gog" },
  { label: "Epic Games Store", value: "epic" },
  { label: "Windows DRM-Free", value: "windows" },
  { label: "Mac OS DRM-Free", value: "mac" },
  { label: "DRM-Free Keys", value: "drmfree" },
  { label: "PS4", value: "ps4" },
  { label: "XBOX ONE", value: "xbox1" },
  { label: "Nintendo Switch eShop", value: "switch" },
  { label: "Linux DRM-Free", value: "linux" }
];

const currs = [
  { label: "USD", value: "USD", default: true },
  { label: "EUR", value: "EUR" },
  { label: "RUB", value: "RUB" },
];

export function PAInputPricesPrice({
  sku = 0,
  priceId = "USD",
  handeCurrDel = ()=>{void(0)},
  currLocked = false,
  index = 0,
  platf = []
}) {
  const [state, setState] = useState({});

  let context = useContext(GlobalContext);

  let keyContext = useContext(KeyContext);

  const handleValue = (what = "price", value) => {
    if (keyContext) {
      let newCurs = keyContext.keyState.data.keyData["curs"];

      if (!newCurs[priceId]) {
        newCurs[priceId] = { ...newCurs[0] };
      }
      newCurs[priceId][what] = value;

      keyContext.handleKeyState("data", {
        ...keyContext.keyState.data,
        keyData: {
          ...keyContext.keyState.data.keyData,
          curs: [...newCurs]
        }
      });
    }
  };

  useEffect(() => {});

  return (

    <FormGroup label={
        currLocked ? `Default currency and price` :
        index === 1 ? 'Platform and currency specific prices' : ''
      }
      tooltip={currLocked ? 'This price is used as a default if not set up otherwise. It is automatically converted to a local currency if needed.' : ''}
      indentation="xs"
    >
    <div
      style={{
        // display: "grid",
        display: "flex",
        // gridTemplateColumns: 'repeat(3, 1fr)',
        // gridAutoColumns: 'minmax(30% 50%)'
      }}
    >




         {!currLocked && <div
          className="xsui-input--dock-right"
          style={{
            flexGrow: 0,
            width: '33%',
            flexBasis: '33%',
          }}
         ><Select
          // disabled={this.disabled}
          name=""
          options={platf}
          searchable={false}
          autosize={false}
          dock={"right"}
          size={"md"}
          disabled={currLocked ? true : false}
          input={{
            name: "test",
            onChange: e => {
              handleValue("platform", e);
            },
            value: keyContext.keyState.data.keyData.curs[priceId]
              ? keyContext.keyState.data.keyData.curs[priceId]["platform"]
              : platf[0]["value"]
          }}
        /></div>}


        {/* <FormGroup border={false}> */}
        <div
          style={{
            flexGrow: 0,
            flexBasis: '33%',
          }}
          className={!currLocked ? 'xsui-price-input-center' : ''}
        >
          <Select
            // disabled={this.disabled}
            name=""
            options={currs}
            searchable={false}
            autosize={false}
            dock={"right"}
            size={"md"}
            input={{
              onChange: e => {
                handleValue("curr", e);
              },
              value: keyContext.keyState.data.keyData.curs[priceId]
                ? keyContext.keyState.data.keyData.curs[priceId]["curr"]
                : currs[0]["value"]
            }}
          />
        </div>

        {/* </FormGroup> */}

        {keyContext && keyContext.keyState.data && (
          <Input
            style={{
              flexGrow: 1,
              flexBasis: '33%',
            }}
            dock={"left"}
            input={{
              name: "with-icon",
              value: keyContext.keyState.data.keyData.curs[priceId]
                ? keyContext.keyState.data.keyData.curs[priceId]["price"]
                : 0,
              // extraLabel: keyContext.keyState.data.keyData.curs[priceId].currLocked
              // ? "DEFAULT" : null,
              onChange: e => {
                handleValue("price", e.target.value);
              }
            }}
            offset="right"
            extra={
              <Icon
                name={
                  keyContext.keyState.data.keyData.curs[priceId]
                    ? keyContext.keyState.data.keyData.curs[priceId].currLocked
                      ? "null"
                      : "delete"
                    : "null"
                }
                hoverable={true}
                onClick={e => handeCurrDel(priceId, e)}
              />
            }
          />
        )}

    </div>
    </FormGroup>
  );
}
